const accordions: NodeListOf<Element> = document.querySelectorAll('.c-faq__main');
const accordionItems: NodeListOf<Element> = document.querySelectorAll('.o-accordion');
const cFaqAccordions: NodeListOf<Element> = document.querySelectorAll('.c-faq__accordion');
const faqSearchBlock: NodeListOf<Element> = document.querySelectorAll('.c-faq__search');
const faqCloseSearch: NodeListOf<Element> = document.querySelectorAll('.c-faq__search-close');
const faqSearchResults: NodeListOf<Element> = document.querySelectorAll('.c-faq__search-results');

function performSearch(): void {
    const searchQuery: string = (document.getElementById('searchInput') as HTMLInputElement).value.toLowerCase();
    const searchLength: number = searchQuery.length;
    let i: number = 0;

    if (searchLength >= 3) {
        accordionItems.forEach((item: Element) => {
            const accordionText: string = item.textContent?.toLowerCase() || '';
            
            if (accordionText.includes(searchQuery)) {
                i++;
                item.classList.add('match');
                item.removeAttribute('open');
                cFaqAccordions.forEach((accordion: Element) => {
                    accordion.classList.add('is-visible');
                });
    
                accordions.forEach((accordion: Element) => {
                    accordion.classList.add('search-initialized');
                });

                faqSearchBlock.forEach((item: Element) => {
                    item.classList.add('search-initialized');
                });

                faqSearchResults.forEach((item: Element) => {
                    item.classList.add('search-initialized');
                    item.textContent = `We found ${i} matches to your request:`;
                });
            } else {
                item.classList.remove('match');
            }
        });
    } else {
        cFaqAccordions.forEach((accordion: Element) => {
            accordion.classList.remove('is-visible');
        });

        accordions.forEach((accordion: Element) => {
            accordion.classList.remove('search-initialized');
        });

        faqSearchBlock.forEach((item: Element) => {
            item.classList.remove('search-initialized');
        });

        faqSearchResults.forEach((item: Element) => {
            item.classList.remove('search-initialized');
            item.textContent = '';
        });

        const activeCategory: Element | null = document.querySelector('.c-faq__category.is-active');
        const activeCategoryHandle: string | null = activeCategory.getAttribute('data-category-handle');
        cFaqAccordions.forEach((accordion: Element) => {
            const accordionCategory: string | null = accordion.getAttribute('data-accordion-category');

            if (accordionCategory === activeCategoryHandle) {
                accordion.classList.add('is-visible');
            } else {
                accordion.classList.remove('is-visible');
            }
        });
    }
}

function removeSearch(): void {
    const searchInput = document.getElementById('searchInput') as HTMLInputElement;
    searchInput.value = '';

    performSearch();
}

document.getElementById('searchInput')?.addEventListener('input', performSearch);

faqCloseSearch.forEach((item: Element) => {
    item.addEventListener('click', removeSearch);
});